export const columnFields = [
	'organizationId',
	//
	'name',
	//
	'customerId',
] as const;
